/**
 * @param {number} amount number to be converted to currency string
 * @param {number | undefined} minimumFractionDigitsOverride
 * @returns currency string
 */
export const toCurrency = (amount: number, minimumFractionDigitsOverride?: number): string => {
  // Use override or
  // If there are cents, minimumFractionDigits should be 2, otherwise 0
  const calculated = amount.toString()
    .split('.')[1]
    ? 2
    : 0
  const minimumFractionDigits = minimumFractionDigitsOverride || calculated
  return amount.toLocaleString('US', {
    style: 'currency',
    currency: 'USD',
    minimumFractionDigits,
  })
}

export const subtractCurrency = (a: number, b: number): number => (
  parseFloat((a - b).toFixed(2))
)

export const addCurrency = (a: number, b: number): number => (
  parseFloat((a + b).toFixed(2))
)

export const centsToDollars = (dollar: number): number => (
  parseFloat((dollar / 100).toFixed(2))
)

export const dollarsToCents = (dollar: number): number => (
  parseInt((dollar * 100).toFixed(0), 10)
)
